module.exports = __webpack_public_path__ + "img/folder.a6bdd8f8.svg";